import React from 'react';
import './App.css';
import Body from './routes/Body';

function App() {
  return (
    <div className="App">
      <Body />
    </div>
  );
}

export default App;
